<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-2">Edit Group Name</p>
        <v-row>
          <v-col class="pb-0" cols="12" sm="12" md="12">
            <v-text-field
              v-model="groupName"
              label="Group Name"
              required
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            text
            @click="finish"
            >Finish</v-btn
          >
          <v-btn
            class="font-weight-bold"
            color="grey darken-1"
            text
            @click="cancel"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      groupName: '',
      bedId: -1,
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      /**
       * @type {string}
       */
      unitListAddressId: undefined
    }
  },
  methods: {
    open({ oldName, addressId }) {
      this.groupName = oldName
      this.unitListAddressId = addressId
      this.dialog = true
      //this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      try {
        this.$root.$setLoading(true)
        await this.$store.dispatch('units/updateGroupNameAction', {
          groupName: this.groupName,
          addressId: this.unitListAddressId
        })
        this.dialog = false
        this.$root.$setLoading(false)
        this.resolve(true)
      } catch (err) {
        this.$root
          .$confirm({
            title: 'Update Group Name Error',
            message: err,
            reconfirmOnly: true,
            confirmText: 'OK',
            options: {
              color: 'error'
            }
          })
          .then(() => {
            this.loading = false
            this.$root.$setLoading(false)
            this.reject(false)
          })
      }
    },
    cancel() {
      this.dialog = false
      this.$root.$setLoading(false)
      this.resolve(false)
    }
  }
}
</script>
